'use client'

export const dynamic = 'force-dynamic'

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="it">
      <body>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif', gap: '16px' }}>
          <h2 style={{ fontSize: '1.25rem', color: '#242164' }}>Si è verificato un errore imprevisto.</h2>
          <button
            onClick={reset}
            style={{ padding: '8px 20px', background: '#FE7200', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}
          >
            Riprova
          </button>
        </div>
      </body>
    </html>
  )
}
